import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { createCustomFilterProperties } from '@/routes/projectStages/issues/lib/issuesHelpers/createCustomFiltersProperties.tsx'
import { AVAILABLE_PROPERTIES } from '@/routes/projectStages/issue/types/issue.ts'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import {
  createdAtProperty,
  deadlineProperty,
  updatedAtProperty,
} from '@/routes/root/lib/staticProperties.tsx'
import createSeparator from '@/components/common/propertyPopoverOverlay/createSeparator.tsx'

/* Create nested filter popover for each of relevant properties available for current user.
 Possible properties:
 - custom filters (optional)
 - recipients (optional)
 - statuses (optional)
 - deadline (optional)
 - labels - one separate for each label group (optional)
 ###
 - creators
 - created at
 - clear filters
 */
export default function getAvailableFilters(
  recipientsProperty: PopoverProperty,
  creatorsProperty: PopoverProperty,
  labelGroupsProperties: PopoverProperty[],
  currIssueType: IssueTypeT | null,
  statusGroupProperty: PopoverProperty,
  clearFiltersProperty: PopoverProperty,
  locationProperty: PopoverProperty,
): { allFiltersProperties: PopoverProperty[] } {
  let allFiltersProperties: PopoverProperty[] = []
  const availableProperties = currIssueType?.availableProperties as AVAILABLE_PROPERTIES[]

  // add custom filters if they exist
  const customFilters = currIssueType?.currentUserCustomFilters
  const customFiltersProperties = createCustomFilterProperties(customFilters)

  if (customFiltersProperties.length > 0) {
    allFiltersProperties.push(...customFiltersProperties)
    allFiltersProperties.push(createSeparator())
  }

  // add creators prop
  allFiltersProperties.push(creatorsProperty)

  // add dynamic properties depending on what the user has access to
  availableProperties?.forEach(property => {
    if (property === 'hasRecipient') {
      allFiltersProperties.push(recipientsProperty)
      allFiltersProperties.push(createSeparator())
    }

    if (property.startsWith('/status_groups/')) {
      allFiltersProperties.push(statusGroupProperty)
      allFiltersProperties.push(createSeparator())
    }

    if (property === 'hasLocation') {
      allFiltersProperties.push(locationProperty)
      allFiltersProperties.push(createSeparator())
    }

    if (property.startsWith(`/label_groups/`)) {
      const labelGroupProp = labelGroupsProperties.find(group => group.id === property)
      if (labelGroupProp) {
        allFiltersProperties.push(labelGroupProp)
      }
    }
  })

  // add deadline if exists
  if (availableProperties?.some(p => p.includes('hasDueDate'))) {
    allFiltersProperties.push(deadlineProperty)
  }

  // add created at always
  allFiltersProperties.push(createdAtProperty)
  allFiltersProperties.push(updatedAtProperty)
  allFiltersProperties.push(createSeparator())

  // add clear filters property - logic of clearing filters will be inside issuesFiltersAll
  allFiltersProperties.push(clearFiltersProperty)

  return { allFiltersProperties }
}
